import React from 'react';
import { Dialog, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from '../..';
import { ClosableDialogTitle, ClosableDialogContent } from '../ClosableDialog';
import { CustomerList } from './CustomerList';
import { runningOnCanvas } from '../../utils/canvas';
export default function CustomerPopup(props) {
    var t = useTranslation().t;
    var theme = useTheme();
    var phoneView = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
    return (React.createElement(Dialog, { onClose: runningOnCanvas() ? undefined : props.onClose, "aria-labelledby": "customized-dialog-title", open: true, className: "customerFleetListDialog", fullWidth: true, maxWidth: "md", fullScreen: phoneView },
        React.createElement(ClosableDialogTitle, { onClose: runningOnCanvas() ? undefined : props.onClose }, t('Select Account')),
        React.createElement(ClosableDialogContent, { dividers: true, style: { padding: 0 } },
            props.alertMessage
                && (React.createElement("div", { style: { padding: 16, backgroundColor: '#e8f2f5', borderBottom: 'solid 1px #00000011' } }, props.alertMessage)),
            React.createElement("div", { className: "customerFleetList" },
                React.createElement(CustomerList, { onClose: props.onClose, levels: props.levels, accountType: props.accountType, countryCodes: props.countryCodes, custChnlCodes: props.custChnlCodes, enableStateFiltering: props.enableStateFiltering })))));
}
//# sourceMappingURL=CustomerPopup.js.map